import { getWindow } from "../helpers/getWindow";
import { memo } from "../helpers/memo";

const computeIsPersistingForbidden = (): boolean => {
    const window = getWindow();

    try {
        window?.localStorage.getItem("wcom_opt_usr");
        return false;
    } catch {
        return true;
    }
};

const getIsPersistingForbidden = memo(computeIsPersistingForbidden);
export const useIsPersistingForbidden = (): boolean =>
    getIsPersistingForbidden("isPersistingForbidden");
